import React, { FunctionComponent } from 'react';
import { Box, FormHelperText, Grid, Hidden, makeStyles, Theme } from '@material-ui/core';
import gray from '@material-ui/core/colors/grey';
import InputTextComponent from '../../../InputTextField';
import classNames from 'classnames';
import { FormFieldProps } from '../FormFieldDisplay';

const useStyles = makeStyles((theme: Theme) => ({
    inputCustomStyle: {
        fontSize: 16,
    },
    detailNodeLabelSm: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textAlign: 'left',
        justifyContent: 'right',
        marginRight: 30,
        lineHeight: '21px',
    },
    detailNodeLabel: {
        fontSize: 14,
        fontWeight: 500,
        color: theme.palette.text.secondary,
        textAlign: 'right',
        justifyContent: 'right',
        marginRight: 30,
        lineHeight: '21px',
    },
    detailNodeValue: {
        fontSize: 14,
        fontWeight: 450,
        color: gray[600],
        lineHeight: '21px',
        wordWrap: 'break-word',
        width: '100%',
    },
    borderedInputs: {
        border: '1px solid rgb(0,0,0,0.23) !important',
        padding: 10,
        borderRadius: 3,
        marginBottom: '5px',
    },
    disabled: {
        color: '#484848 !important',
    },
}));

const TextFormField: FunctionComponent<FormFieldProps> = (props) => {
    const { formField, value, error, readOnly, handleInputChange, isCustomStyle = false } = props;

    const classes = useStyles();
    const inputClasses = classNames({
        [classes.inputCustomStyle]: true,
        [classes.disabled]: !readOnly,
        [classes.borderedInputs]: !readOnly,
    });

    const textValue: string = typeof value === 'string' ? value : '';

    return (
        <Grid container alignItems={readOnly ? 'flex-start' : 'center'}>
            <Grid
                item
                xs={isCustomStyle ? 3 : 6}
                sm={isCustomStyle ? 3 : 6}
                md={isCustomStyle ? 3 : 6}
                lg={isCustomStyle ? 3 : 6}
            >
                <Hidden smUp={true}>
                    <Box component="div" className={classes.detailNodeLabelSm}>
                        {formField.label}{' '}
                    </Box>
                </Hidden>
                <Hidden xsDown={true}>
                    <Box component="div" className={classes.detailNodeLabel}>
                        {formField.label}{' '}
                    </Box>
                </Hidden>
            </Grid>
            <Grid
                item
                xs={isCustomStyle ? 9 : 6}
                sm={isCustomStyle ? 9 : 6}
                md={isCustomStyle ? 9 : 6}
                lg={isCustomStyle ? 9 : 6}
            >
                <Box component="div" className={classes.detailNodeValue}>
                    {!readOnly && (
                        <>
                            <InputTextComponent
                                disabled={!!readOnly}
                                size="small"
                                id={formField.field}
                                value={textValue}
                                error={error?.error}
                                className={classes.detailNodeValue}
                                inputProps={inputClasses}
                                disableUnderline={readOnly ? true : false}
                                fontSize="13"
                                onChange={(value: any) => {
                                    handleInputChange(formField.field, value);
                                }}
                            />
                            {error?.messages?.map((msg, index) => (
                                <FormHelperText key={index} error={true}>
                                    {msg}
                                </FormHelperText>
                            ))}
                        </>
                    )}
                    {readOnly && (
                        <Box component="div" className={classes.detailNodeValue}>
                            {textValue}
                        </Box>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default TextFormField;
